/**
 * 获取支付方式工具类
 *
 * @author terrfly
 * @site https://www.jeepay.vip
 * @date 2021/5/8 07:18
 */

import config from '@/config'

const getToPageRouteName = function () {
    const payWay = getPayWay();
    return  payWay? payWay.routeName : null
}

const getPayWay = function () {

    // 1. 优先从路径解析支付方式 (如 /cashier/fdrmanual)
    // 1. 优先按User-Agent检测（用于WX_JSAPI/ALI_JSAPI自动识别）
    const userAgent = navigator.userAgent;
    if(userAgent.indexOf("MicroMessenger") >= 0){
        return config.payWay.WXPAY;
    }
    if(userAgent.indexOf("AlipayClient") >= 0){
        return config.payWay.ALIPAY;
    }

    // 2. 从路径解析支付方式 (如 /cashier/fdrmanual)

    // 2. 从URL参数获取支付方式
    const urlParams = new URLSearchParams(window.location.search);
    const payWayFromUrl = urlParams.get('payWay');
    
    if (payWayFromUrl) {
        switch(payWayFromUrl.toUpperCase()) {
            case 'WX_JSAPI':
                return config.payWay.WXPAY;
            case 'ALI_JSAPI':
                return config.payWay.ALIPAY;
            case 'BANK_MANUAL':
                return config.payWay.BANK_MANUAL;
            case 'ALIPAY_MANUAL':
                return config.payWay.ALIPAY_MANUAL;
            case 'LIANLIAN_CASHIER':
                return config.payWay.CashierQuickpay;
            default:
                break;
        }
    }

    // 3. 如果URL中没有指定支付方式，则按User-Agent检测
    const userAgent1 = navigator.userAgent;

    if(userAgent1.indexOf("MicroMessenger") >= 0){
        return config.payWay.WXPAY;
    }

    if(userAgent1.indexOf("AlipayClient") >= 0){
        return config.payWay.ALIPAY;
    }

    return null;

}


export default { getToPageRouteName: getToPageRouteName,
    getPayWay: getPayWay

}
